// extracted by mini-css-extract-plugin
export default {"base":"base-c759E","heading":"heading-W8uUD","item":"item-GXt52","heart":"heart-p1gYb","heartOutline":"heartOutline-kq1Fm","iconSlotComponentButton":"iconSlotComponentButton-qZcQh"};